import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingService {

  public loading$: Observable<boolean>;
  private _loading$: BehaviorSubject<boolean>;
  private loaderMap: {[x: string]: Observable<boolean>} = {};
  private prevValues: {[x: string]: boolean} = {};

  constructor() {
    this._loading$ = new BehaviorSubject<boolean>(false);
    this.loading$ = this._loading$.pipe();
  }

  public addLoader(key: string, loader: Observable<boolean>) {
    // 1回しか登録しない
    if (this.loading$[key]) {
      return;
    }

    this.loaderMap[key] = loader;
    loader.subscribe(ret => {
      this.prevValues[key] = ret;

      let sumLoading = false;
      Object.keys(this.prevValues).forEach(subKey => {
        if (this.prevValues[subKey]) {
          sumLoading = true;
        }
      });
      this._loading$.next(sumLoading);
    });
  }
}
